module.exports = __webpack_public_path__ + "images/cebsblogo_white.1789354321160.png";